import React from "react";

const toAlignClass = (a) => {
  const v = String(a || "").toLowerCase().trim();
  if (v === "center") return "text-center";
  if (v === "right") return "text-right";
  if (v === "left") return "text-left";
  return "";
};

const buildBg = (style, defaultClass) => {
  const mode = style?.bgMode || "default";

  if (mode === "solid" && style?.bgColor) {
    return { style: { backgroundColor: style.bgColor }, className: "" };
  }

  if (mode === "gradient") {
    const from = (style?.bgGradientFrom || "").trim();
    const via = (style?.bgGradientVia || "").trim();
    const to = (style?.bgGradientTo || "").trim();
    const angleNum = Number(style?.bgGradientAngle);
    const angle = Number.isFinite(angleNum) ? angleNum : 180;

    if (from && to) {
      const stops = via ? `${from}, ${via}, ${to}` : `${from}, ${to}`;
      return {
        style: { backgroundImage: `linear-gradient(${angle}deg, ${stops})` },
        className: "",
      };
    }
  }

  return { style: undefined, className: defaultClass };
};

const FeaturesSection1 = ({ config, style }) => {
  const bg = buildBg(style, "bg-gray-50");

  const align = (style?.textAlign || "").trim();
  const hasAlign = align.length > 0;

  const headerAlignClass = hasAlign ? toAlignClass(align) : "text-center";
  const cardAlignClass = hasAlign ? toAlignClass(align) : "";

  return (
    <section
      dir={config.direction || "ltr"}
      style={bg.style}
      className={`py-14 px-4 ${bg.className}`}
    >
      <div className="container mx-auto max-w-7xl">
        <div className={`${headerAlignClass} mb-16`}>
          <h2
            style={{ color: style?.titleColor || undefined }}
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
          >
            {config.title}
          </h2>
          <p
            style={{ color: style?.subtitleColor || undefined }}
            className="text-xl text-gray-600 max-w-3xl mx-auto"
          >
            {config.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {config.features?.map((feature, index) => (
            <div
              key={index}
              style={{
                backgroundColor: style?.featuresCardBg || undefined,
                borderColor: style?.featuresCardBorder || undefined,
              }}
              className={`p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 ${
                style?.featuresCardBg || style?.featuresCardBorder ? "border" : "bg-white"
              } ${cardAlignClass}`}
            >
              <div className="text-4xl mb-6">{feature.icon}</div>
              <h3
                style={{ color: style?.featuresCardTitleColor || undefined }}
                className="text-xl font-bold text-gray-900 mb-4"
              >
                {feature.title}
              </h3>
              <p
                style={{ color: style?.featuresCardDescriptionColor || undefined }}
                className="text-gray-600"
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection1;